module.exports = __webpack_public_path__ + "408e99626e30dda336973576519a7cd8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.html
// module id = 2527
// module chunks = 0